var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header-right"},[_c('h4',{staticClass:"pr-1"},[_vm._v(" Hi "+_vm._s(_vm.username)+" "),_c('status-indicator',{attrs:{"negative":_vm.alarm,"positive":!_vm.alarm,"pulse":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }